import script from "./UserFinancial.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserFinancial.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__